import type {TravelType} from '@/modules/common/context/QueryParams/models';
import type {Page} from '@/types';

import {PAGE_HOTELS, PAGE_OFFERS} from '@/consts';
import {TravelTypes} from '@/modules/common/context/QueryParams/models';

const PLACEMENT_ID = {
  HOTEL_LIST_PT: 'bd4t-reco-pl-pa-bottom-empty',
  HOTEL_LIST_OA: 'bd4t-reco-pl-ho-bottom-empty',
  OFFER_LIST_PT: 'bd4t-reco-pdp-pa-bottom-empty',
  OFFER_LIST_OA: 'bd4t-reco-pdp-ho-bottom-empty',
};
const PLACEMENT_ID_MAP: Record<Page, Record<TravelType, string>> = {
  [PAGE_HOTELS]: {
    [TravelTypes.packageTour]: PLACEMENT_ID.HOTEL_LIST_PT,
    [TravelTypes.ownArrival]: PLACEMENT_ID.HOTEL_LIST_OA,
  },
  [PAGE_OFFERS]: {
    [TravelTypes.packageTour]: PLACEMENT_ID.OFFER_LIST_PT,
    [TravelTypes.ownArrival]: PLACEMENT_ID.OFFER_LIST_OA,
  },
};

export const getPlacementId = ({
  page,
  travelType,
}: {
  page: Page;
  travelType: TravelType;
}): string => {
  return PLACEMENT_ID_MAP[page][travelType];
};
